import { useEffect, useRef, useState } from "react";
import DetailedFile from "../../../Editor/FolderModal/DetailedFile";
import RegularFile from "../../../Editor/FolderModal/RegularFile";
import { useGlobalContext } from "../../../Context/Context";
import axios from "axios";
import "./addDocumentEditor.css";
import rightIcon from "./images/play-right.png";
import leftIcon from "./images/play-left.png";
import DetailedFileAdmin from "./DetailedFileAdmin";

const AddDocumentEditor = ({
  setNewFiles,
  setAddingChecked,
  location,
  setViewDocument,
  viewDocument,
  setFilteringChecked,
  setAddingDocument,
}) => {
  const [documents, setDocuments] = useState([]);
  const [showingDocuments, setShowingDocuments] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [detailedFile, setDetailedFile] = useState([]);

  const maxPerPage = 13;

  const numberOfPages = useRef();

  const { apiKey, baseUrl, loggedUser } = useGlobalContext();

  const calculatePagination = (documents) => {
    numberOfPages.current = parseInt(documents.length / maxPerPage);
    let leftOvers = documents.length % maxPerPage;
    if (leftOvers > 0) numberOfPages.current += 1;
    const items = documents.slice(0, maxPerPage);
    setShowingDocuments(items);
  };

  const handlePagination = (isLeft) => {
    let newCurrentIndex = currentIndex;
    if (isLeft) newCurrentIndex -= 1;
    else newCurrentIndex += 1;
    setCurrentIndex(newCurrentIndex);
    let indexEnd =
      newCurrentIndex * maxPerPage + maxPerPage > documents.length
        ? documents.length
        : newCurrentIndex * maxPerPage + maxPerPage;
    console.log(indexEnd);
    const newItems = documents.slice(newCurrentIndex * maxPerPage, indexEnd);
    setShowingDocuments(newItems);
  };

  useEffect(() => {
    const handleGetDocuments = async () => {
      try {
        axios
          .post(`${baseUrl}/location_documents/getItemDocuments.php`, {
            user_id: loggedUser.id,
            location_id: location?.location_id || location.location_id,
            api_key: apiKey,
          })
          .then((data) => {
            console.log("Poziva se vraca dokumenta", data.data.documents);
            if (data.data.status === 200) {
              // ZAMENI OVO KASNIJE
              const items = [...data.data.documents];
              setDocuments(items);
              calculatePagination(items);
            }
          });
      } catch (error) {
        console.log("Error fetching messages");
      }
    };
    handleGetDocuments();
  }, []);

  return (
    <div className="folder-add-documents">
      {showingDocuments.map((file, index) => {
        return (
          <article className="folder-modal-file">
            {detailedFile.find((f) => f === index) !== undefined ? (
              <DetailedFileAdmin
                file={file}
                index={currentIndex * maxPerPage + index}
                detailedFile={detailedFile}
                setDetailedFile={setDetailedFile}
                setFilteringChecked={setFilteringChecked}
                setAddingChecked={setAddingChecked}
                setAddingDocument={setAddingDocument}
                location={location}
              />
            ) : (
              <RegularFile
                setViewDocument={setViewDocument}
                viewDocument={viewDocument}
                document={file}
                index={currentIndex * maxPerPage + index}
                setDetailedFile={setDetailedFile}
                location={location}
                detailedFile={detailedFile}
              />
            )}
          </article>
        );
      })}
      <div className="folder-add-pagination-wrapper">
        <div className="folder-add-pagination">
          <div className="folder-add-pagination-left">
            {currentIndex !== 0 && (
              <img
                src={leftIcon}
                alt=""
                onClick={() => handlePagination(true)}
              />
            )}
          </div>
          <span className="folder-add-pagination-middle">
            {documents.length}
          </span>
          <div className="folder-add-pagination-right">
            {currentIndex !== numberOfPages.current - 1 && (
              <img
                src={rightIcon}
                alt=""
                onClick={() => handlePagination(false)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDocumentEditor;
